import Cli from './cli/index.md'
import CliReact from './cli/react.md'
import CliVue from './cli/vue.md'
import CliSvelte from './cli/svelte.md'
import CliAngular from './cli/angular.md'
import Structure from './structure/index.md'
import StructureReact from './structure/react.md'
import StructureVue from './structure/vue.md'
import StructureSvelte from './structure/svelte.md'
import StructureAngular from './structure/angular.md'
import Style from './styles/index.md'
import StyleReact from './styles/react.md'
import StyleVue from './styles/vue.md'
import StyleSvelte from './styles/svelte.md'
import StyleAngular from './styles/angular.md'
import Static from './assets/index.mdx'
import StaticReact from './assets/react.md'
import StaticVue from './assets/vue.md'
import StaticSvelte from './assets/svelte.md'
import StaticAngular from './assets/angular.md'
import Start from './start/index.md'
import StartReact from './start/react.md'
import StartVue from './start/vue.md'
import StartSvelte from './start/svelte.md'
import StartAngular from './start/angular.md'
import Component from './component/index.md'
import ComponentReact from './component/react.md'
import ComponentVue from './component/vue.md'
import ComponentSvelte from './component/svelte.md'
import ComponentAngular from './component/angular.md'
import State from './state/index.md'
import StateReact from './state/react.md'
import StateVue from './state/vue.md'
import StateSvelte from './state/svelte.md'
import StateAngular from './state/angular.md'
import Fetch from './fetch/index.md'
import FetchReact from './fetch/react.md'
import FetchSvelte from './fetch/svelte.md'
import FetchVue from './fetch/vue.md'
import FetchAngular from './fetch/angular.md'
import Children from './children/index.md'
import ChildrenReact from './children/react.md'
import ChildrenVue from './children/vue.md'
import ChildrenSvelte from './children/svelte.md'
import ChildrenAngular from './children/angular.md'
import List from './list/index.md'
import ListReact from './list/react.md'
import ListVue from './list/vue.md'
import ListSvelte from './list/svelte.md'
import ListAngular from './list/angular.md'
import Conditional from './conditional/index.md'
import ConditionalReact from './conditional/react.md'
import ConditionalSvelte from './conditional/svelte.md'
import ConditionalVue from './conditional/vue.md'
import ConditionalAngular from './conditional/angular.md'
import Atributes from './atributes/index.md'
import AtributesReact from './atributes/react.md'
import AtributesVue from './atributes/vue.md'
import AtributesSvelte from './atributes/svelte.md'
import AtributesAngular from './atributes/angular.md'
import Form from './forms/index.md'
import FormReact from './forms/react.md'
import FormSvelte from './forms/svelte.md'
import FormVue from './forms/vue.md'
import FormAngular from './forms/angular.md'
import Parents from './parents/index.md'
import ParentReact from './parents/react.md'
import ParentSvelte from './parents/svelte.md'
import ParentVue from './parents/vue.md'
import ParentAngular from './parents/angular.md'
import PokedexTab from './pokedex-tab'

export const options = [
  {
    id: 'react',
    title: 'React',
    component: <PokedexTab src="/images/pokedex/react.svg" title="react" />,
  },
  {
    id: 'svelte',
    title: 'Svelte',
    component: <PokedexTab src="/images/pokedex/svelte.svg" title="svelte" />,
  },
  {
    id: 'vue',
    title: 'Vue',
    component: <PokedexTab src="/images/pokedex/vue.svg" title="vue" />,
  },
  {
    id: 'angular',
    title: 'Angular',
    component: <PokedexTab src="/images/pokedex/angular.svg" title="angular" />,
  },
]

export const firstSection = {
  title: 'CLIs',
  id: 'cli',
  content: <Cli />,
  tabs: [
    {
      id: 'cli-react',
      component: <CliReact />,
    },
    {
      id: 'cli-svelte',
      component: <CliSvelte />,
    },
    {
      id: 'cli-vue',
      component: <CliVue />,
    },
    {
      id: 'cli-angular',
      component: <CliAngular />,
    },
  ],
}

const data = [
  {
    title: 'Estructura de la aplicación',
    id: 'estructura',
    content: <Structure />,
    tabs: [
      {
        id: 'structure-react',
        component: <StructureReact />,
      },
      {
        id: 'structure-svelte',
        component: <StructureSvelte />,
      },
      {
        id: 'structure-vue',
        component: <StructureVue />,
      },
      {
        id: 'structure-angular',
        component: <StructureAngular />,
      },
    ],
  },
  {
    title: '¿Cómo se inicializa la aplicación?',
    id: 'iniciando',
    content: <Start />,
    tabs: [
      {
        id: 'start-react',
        component: <StartReact />,
      },
      {
        id: 'start-svelte',
        component: <StartSvelte />,
      },
      {
        id: 'start-vue',
        component: <StartVue />,
      },
      {
        id: 'start-angular',
        component: <StartAngular />,
      },
    ],
  },
  {
    title: '¿Cómo creó mis componentes?',
    id: 'componentes',
    content: <Component />,
    tabs: [
      {
        id: 'component-react',
        component: <ComponentReact />,
      },
      {
        id: 'component-svelte',
        component: <ComponentSvelte />,
      },
      {
        id: 'component-vue',
        component: <ComponentVue />,
      },
      {
        id: 'component-angular',
        component: <ComponentAngular />,
      },
    ],
  },
  {
    title: '¿Cómo utilizo los estilos?',
    id: 'estilos',
    content: <Style />,
    tabs: [
      {
        id: 'styles-react',
        component: <StyleReact />,
      },
      {
        id: 'styles-svelte',
        component: <StyleSvelte />,
      },
      {
        id: 'styles-vue',
        component: <StyleVue />,
      },
      {
        id: 'styles-angular',
        component: <StyleAngular />,
      },
    ],
  },
  {
    title: '¿Cómo utilizo los archivos estáticos?',
    id: 'estático',
    content: <Static />,
    tabs: [
      {
        id: 'static-react',
        component: <StaticReact />,
      },
      {
        id: 'static-svelte',
        component: <StaticSvelte />,
      },
      {
        id: 'static-vue',
        component: <StaticVue />,
      },
      {
        id: 'static-angular',
        component: <StaticAngular />,
      },
    ],
  },
  {
    title: '¿Cómo creó y actualizo el estado?',
    id: 'estado',
    content: <State />,
    tabs: [
      {
        id: 'state-react',
        component: <StateReact />,
      },
      {
        id: 'state-svelte',
        component: <StateSvelte />,
      },
      {
        id: 'state-vue',
        component: <StateVue />,
      },
      {
        id: 'state-angular',
        component: <StateAngular />,
      },
    ],
  },
  {
    title: '¿Cómo traigo datos de una API?',
    id: 'fetch',
    content: <Fetch />,
    tabs: [
      {
        id: 'fetch-react',
        component: <FetchReact />,
      },
      {
        id: 'fetch-svelte',
        component: <FetchSvelte />,
      },
      {
        id: 'fetch-vue',
        component: <FetchVue />,
      },
      {
        id: 'fetch-angular',
        component: <FetchAngular />,
      },
    ],
  },
  {
    title: '¿Cómo le paso información a los hijos?',
    id: 'children',
    content: <Children />,
    tabs: [
      {
        id: 'children-react',
        component: <ChildrenReact />,
      },
      {
        id: 'children-svelte',
        component: <ChildrenSvelte />,
      },
      {
        id: 'children-vue',
        component: <ChildrenVue />,
      },
      {
        id: 'children-angular',
        component: <ChildrenAngular />,
      },
    ],
  },
  {
    title: '¿Cómo renderizo una lista?',
    id: 'listas',
    content: <List />,
    tabs: [
      {
        id: 'list-react',
        component: <ListReact />,
      },
      {
        id: 'list-svelte',
        component: <ListSvelte />,
      },
      {
        id: 'list-vue',
        component: <ListVue />,
      },
      {
        id: 'list-angular',
        component: <ListAngular />,
      },
    ],
  },
  {
    title: 'Componentes condiciones',
    id: 'componentes-condicionales',
    content: <Conditional />,
    tabs: [
      {
        id: 'conditional-react',
        component: <ConditionalReact />,
      },
      {
        id: 'conditional-svelte',
        component: <ConditionalSvelte />,
      },
      {
        id: 'conditional-vue',
        component: <ConditionalVue />,
      },
      {
        id: 'conditional-angular',
        component: <ConditionalAngular />,
      },
    ],
  },
  {
    title: 'Estilos condiciones',
    id: 'estilos-condicionales',
    content: <Atributes />,
    tabs: [
      {
        id: 'conditional-styles-react',
        component: <AtributesReact />,
      },
      {
        id: 'conditional-styles-svelte',
        component: <AtributesSvelte />,
      },
      {
        id: 'conditional-styles-vue',
        component: <AtributesVue />,
      },
      {
        id: 'conditional-styles-angular',
        component: <AtributesAngular />,
      },
    ],
  },
  {
    title: 'Eventos del DOM y formularios',
    id: 'dom',
    content: <Form />,
    tabs: [
      {
        id: 'form-react',
        component: <FormReact />,
      },
      {
        id: 'form-svelte',
        component: <FormSvelte />,
      },
      {
        id: 'form-vue',
        component: <FormVue />,
      },
      {
        id: 'form-angular',
        component: <FormAngular />,
      },
    ],
  },
  {
    title: 'Pasando datos a padres',
    id: 'parents',
    content: <Parents />,
    tabs: [
      {
        id: 'parents-react',
        component: <ParentReact />,
      },
      {
        id: 'parents-svelte',
        component: <ParentSvelte />,
      },
      {
        id: 'parents-vue',
        component: <ParentVue />,
      },
      {
        id: 'parents-angular',
        component: <ParentAngular />,
      },
    ],
  },
]

export default data
